import React, { Component } from 'react'
import GridItems from './GridItems'
import GridMovieInformation from './GridMovieInformation'
import hasGridInformation from '../../hoc/hasGridInformation'
import hasToggleMovieDatesOnMobile from '../../hoc/hasToggleMovieDatesOnMobile'
import { trackMovieInformationOpen } from '../../tracking'
import { getItemsWithInterscroller } from '../../functions/weischerHelpers'
import getMovieLink from '../../functions/getMovieLink'


class FilterResultsGrid extends Component {
    constructor(props) {
        super(props)
    }

    componentDidUpdate(prevProps) {
        const { activeSelection, activeItem, selectionId, closeItemInformation } = this.props

        if (activeSelection !== prevProps.activeSelection) {
            if(activeSelection && activeItem && activeSelection !== selectionId) {
                closeItemInformation()
            }
        }
    }

    render() {
        const { 
            items, 
            itemsData, 
            activeItem, 
            activeDetailsItem,
            itemOnClick,  
            closeItemInformation, 
            openItemDetails, 
            closeItemDetails, 
            displaySidebarRight, 
            displaySidebarRightSecond,
            overviewFilterIgnoreOnPerformances,
            activePerformance, 
            performancePageOpen,
            onOpenPerformancePage,
            onClosePerformancePage,
            hasGridHoverTrailer,
            interscrollerWeischerAds,
            interscrollerAdvertisements,
            movieInformationOrder,
            queryStringValues,
            row,
            isMobile,
            theme,
            stripeAppearance,
            translation,
            moviesRoutesData,
            additionalScrollName = '',
            hideCinemaSelector,
            dayFilters,
            clusterCinemaActive,
            clusterCinemaOption,
            isConnectedFast,
            activeCinema
        } = this.props

        const eventOrigins = {
            poster:                 'Programmübersicht, Grid, Posterelement',
            information:            'Programmübersicht, Grid, Film Information',
            informationSlidebar:    'Programmübersicht, Grid, Film Information/rechte Slidebar',
            details:                'Programmübersicht, Grid, Film Details',
            detailsSlidebar:        'Programmübersicht, Grid, Film Details/rechte Slidebar',
            performance:            'Programmübersicht, Grid, Film Vorführung'
        }

        const integer = Math.ceil(items.length/6) >= 4 ? 6 : 3
        const { interscrollerId, interscrollerType, itemsWithInterscroller } = getItemsWithInterscroller(items, interscrollerWeischerAds, interscrollerAdvertisements, integer)
        const gridClass = isMobile ? '' : stripeAppearance

        return (
            <div className="grid-site-wrapper">
                <div className={"overview-grid " + gridClass}>
                    <GridItems
                        items={itemsWithInterscroller}
                        dayFilters={dayFilters}
                        activeItem={activeItem}
                        stripeAppearance={stripeAppearance}
                        theme={theme}
                        additionalScrollName={additionalScrollName}
                        overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                        itemsData={itemsData}
                        translation={translation}
                        itemOnClick={trackMovieInformationOpen(itemOnClick, eventOrigins.poster)}
                        movieInformationOrder={movieInformationOrder}
                        isMobile={isMobile}
                        hasGridHoverTrailer={hasGridHoverTrailer}
                        interscrollerId={interscrollerId}
                        interscrollerType={interscrollerType}
                        interscrollerWeischerAds={interscrollerWeischerAds}
                        interscrollerAdvertisements={interscrollerAdvertisements}
                        queryStringValues={queryStringValues}
                        isConnectedFast={isConnectedFast}
                        onOpenPerformancePage={onOpenPerformancePage}
                    />

                    <GridMovieInformation
                        clusterCinemaActive={clusterCinemaActive}
                        clusterCinemaOption={clusterCinemaOption}
                        theme={theme}
                        dayFilters={dayFilters}
                        activeCinema={activeCinema}
                        overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                        hideCinemaSelector={hideCinemaSelector}
                        additionalScrollName={additionalScrollName}
                        queryStringValues={queryStringValues}
                        isMobile={isMobile}
                        activeItem={activeItem}
                        itemsData={itemsData}
                        activeDetailsItem={activeDetailsItem}
                        displaySidebarRight={displaySidebarRight}
                        displaySidebarRightSecond={displaySidebarRightSecond}
                        closeItemInformation={closeItemInformation}
                        openItemDetails={openItemDetails}
                        closeItemDetails={closeItemDetails}
                        movieInformationOrder={movieInformationOrder}
                        row={row}
                        activePerformance={activePerformance}
                        translation={translation}
                        itemLink={getMovieLink(activeItem, moviesRoutesData, translation)}
                        eventOrigins={eventOrigins}
                        performancePageOpen={performancePageOpen}
                        onOpenPerformancePage={onOpenPerformancePage}
                        onClosePerformancePage={onClosePerformancePage}
                    />
                </div>
            </div>
        )
    }
}


export default hasGridInformation(FilterResultsGrid)